import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';

import type { IWbuRichTextProps } from '../WbuRichText.props';

export const props = withCompInfo<IWbuRichTextProps, any>()(
  ['compData'],
  ({ compData }) => ({
    ...compData,
    link: compData.link?.resolvedLink,
  }),
);

export default createComponentMapperModel({
  props,
});
